// ONEsentry API Layer - Now connected to NestJS backend

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';

export interface KPIData {
  precisionAtK: number;
  avgTriageMinutes: number;
  dollarsAtRisk: number;
  fairnessParityBadge: 'pass' | 'warning' | 'fail';
}

// Helper function for API calls
async function fetchAPI<T>(endpoint: string, options?: RequestInit): Promise<T> {
  const url = `${API_BASE_URL}/v1${endpoint}`;

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }

    return response.json();
  } catch (error) {
    console.error(`Failed to fetch ${endpoint}:`, error);
    throw error;
  }
}

// API Functions
export const api = {
  // Dashboard
  async getKPIs(): Promise<KPIData> {
    return fetchAPI<KPIData>('/kpis');
  },

  async getQueueSize(): Promise<{ total: number; pending: number; inReview: number }> {
    return fetchAPI<{ total: number; pending: number; inReview: number }>('/queue/size');
  },

  // Auth functionality is now handled by Clerk
};

export function getScoreBand(score: number): 'danger' | 'warning' | 'success' {
  if (score >= 70) return 'danger';
  if (score >= 40) return 'warning';
  return 'success';
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatPercentage(value: number): string {
  return `${(value * 100).toFixed(1)}%`;
}
